import { create } from 'zustand';

// ─── Anmeldezustand der Betreiberkonsole ─────────────────────────────────────
//
// Bewusst NICHT im localStorage: das Access-Token lebt nur im Speicher und ist
// nach einem Neuladen weg – dann holt der Client über den Refresh-Cookie ein
// neues. Ein Token, das in einem durchsuchbaren Speicher liegt, überlebt jeden
// XSS-Fund; eines im Speicher nicht.
//
// Der Refresh-Cookie heißt hier `admin_refresh_token` und ist auf die
// Admin-Domain begrenzt. Eine Anmeldung in der Anwendung stellt hier also
// keine her – und umgekehrt.

export interface AdminUser {
  id: string;
  email: string;
  role: string;
  mustChangePassword: boolean;
  totpEnabled: boolean;
}

interface AdminAuthState {
  user: AdminUser | null;
  accessToken: string | null;
  csrfToken: string | null;
  /** Solange true, läuft der erste Versuch, eine Sitzung wiederherzustellen. */
  wirdGeladen: boolean;

  anmelden: (user: AdminUser, accessToken: string, csrfToken: string) => void;
  abmelden: () => void;
  setzeGeladen: (wert: boolean) => void;
}

export const useAdminAuth = create<AdminAuthState>((set) => ({
  user: null,
  accessToken: null,
  csrfToken: null,
  wirdGeladen: true,

  anmelden: (user, accessToken, csrfToken) =>
    set({ user, accessToken, csrfToken, wirdGeladen: false }),

  abmelden: () => set({ user: null, accessToken: null, csrfToken: null, wirdGeladen: false }),

  setzeGeladen: (wert) => set({ wirdGeladen: wert }),
}));

/** Ist der angemeldete Nutzer Betreiber? Alles hier setzt das voraus. */
export function istBetreiber(user: AdminUser | null): boolean {
  return user?.role === 'admin';
}
